import { render, staticRenderFns } from "./IbxAddToFly.vue?vue&type=template&id=1dea91f0"
import script from "./IbxAddToFly.vue?vue&type=script&lang=js"
export * from "./IbxAddToFly.vue?vue&type=script&lang=js"
import style0 from "./IbxAddToFly.vue?vue&type=style&index=0&id=1dea91f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports